import React from 'react';

import './alertComp.css';

export const AlertComp = ({alertText}) => (
    <div className="alertComp" >
        <i className="fas fa-exclamation-triangle triangle-alert" 
            ></i>
        <p style={{margin: "0 10px"}}>{alertText}</p>
    </div>
) 


// WEBPACK FOOTER //
// ./src/_components/common/AlertComponent/alertComp.js